import React from 'react';
import { EraserIcon } from 'lucide-react';
import type { Aggregates } from '../../../types/pulse';
import { openQuestion } from '../../../data/pulse';
import { sortedThemes } from '../../../utils/pulse';
interface OpenScreenProps {
  value: string;
  onChange: (value: string) => void;
  /** Prompts are ordered by what delegates are actually writing about. */
  aggregates: Aggregates;
}
export function OpenScreen({
  value,
  onChange,
  aggregates
}: OpenScreenProps) {
  const prompts = sortedThemes(aggregates).slice(0, 6);
  const addPrompt = (text: string) => {
    const current = value.trim();
    if (current.toLowerCase().includes(text.toLowerCase())) return;
    onChange(current ? `${current}, ${text.toLowerCase()}` : text);
  };
  return <div className="flex flex-1 flex-col" data-id="element-233" data-mp="2iq90r3vdkq4l">
      <h2 className="font-display text-[22px] font-semibold leading-[1.15] tracking-tight text-navy" data-id="element-234" data-mp="lvw2ory2zp0p">
        {openQuestion.question}
      </h2>
      <p className="mt-3 text-[12.5px] leading-relaxed text-mut" data-id="element-235" data-mp="gxkuelnfpmkl">{openQuestion.support}</p>

      <label className="mt-5 block" data-id="element-236" data-mp="1ed8podjt7ood">
        <span className="sr-only" data-id="element-237" data-mp="1egeb9it8c8fc">Your answer</span>
        <textarea value={value} onChange={e => onChange(e.target.value)} rows={4} maxLength={280} placeholder={openQuestion.placeholder} className="w-full resize-none rounded-xl border border-line bg-mist px-4 py-3.5 text-[13.5px] leading-relaxed text-navy placeholder:text-mut focus:border-blue focus:bg-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-238" data-mp="1igol56k57izh" />
      </label>
      <div className="mt-1.5 flex items-center justify-between gap-3" data-id="element-239" data-mp="1nezrv8f55ddh">
        {value.length > 0 ? <button type="button" onClick={() => onChange('')} className="flex items-center gap-1.5 text-[11px] text-mut transition-colors duration-150 hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-240" data-mp="1sdjhbisy17al">
            <EraserIcon className="h-3 w-3" aria-hidden="true" data-id="element-241" data-mp="2kvx6ku07rky2" />
            Clear my answer
          </button> : <span data-id="element-242" data-mp="2pqhq1ehegci6" />}
        <span className="text-[10px] tabular-nums text-mut" data-id="element-243" data-mp="2psaxux3r12rr">{value.length} / 280</span>
      </div>

      <p className="mt-5 text-[11.5px] font-medium leading-snug text-navy2" data-id="element-244" data-mp="2kqlkhat20d0i">
        {openQuestion.promptLead}
      </p>

      <div className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-245" data-mp="2gq1oiak7vffy">
        {prompts.map(theme => {
        const used = value.toLowerCase().includes(theme.prompt.toLowerCase());
        return <button key={theme.id} type="button" onClick={() => addPrompt(theme.prompt)} className={`rounded-full border px-3 py-1.5 text-[11.5px] leading-none transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue ${used ? 'border-blue bg-blue/[0.08] font-medium text-navy' : 'border-line bg-paper text-navy2 hover:border-blue'}`} data-id="element-246" data-mp="26yxbvhi0k6oa">
              {theme.prompt}
            </button>;
      })}
      </div>

      <p className="mt-auto pt-5 text-[10px] leading-snug text-mut" data-id="element-247" data-mp="8hdegurvhwl9">{openQuestion.promptNote}</p>
    </div>;
}